import React from 'react';
import { FadeIn } from './FadeIn';
import { Camera, Clock, ShoppingBag } from 'lucide-react';
export function PainBlock() {
  const painPoints = [{
    icon: <div className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-179" />,
    text: 'Te pruebas todo el closet y terminas frustrada porque nada te favorece'
  }, {
    icon: <Camera className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-180" />,
    text: 'Evitas las fotos porque no te gusta cómo te ves en ellas'
  }, {
    icon: <Clock className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-181" />,
    text: 'Pierdes 20 minutos cada mañana eligiendo qué ponerte'
  }, {
    icon: <ShoppingBag className="w-6 h-6 text-brand-accent" strokeWidth={1.5} data-id="element-182" />,
    text: 'Compras ropa nueva pero sigues sintiéndote igual'
  }];
  return <section className="bg-brand-primary/20 py-10 sm:py-16 px-4" data-id="element-183">
      <div className="max-w-content mx-auto" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-text mb-10" data-id="element-186">
            ¿Te suena familiar alguna de estas situaciones?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-10" data-id="element-187">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-188">
              <div className="bg-white border border-brand-accent/30 rounded-xl p-6 flex flex-col items-center text-center h-full shadow-sm hover:shadow-md transition-shadow" data-id="element-189">
                <div className="mb-4 p-3 bg-brand-primary/10 rounded-full" data-id="element-190">
                  {point.icon}
                </div>
                <p className="text-brand-text font-medium leading-relaxed" data-id="element-191">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-192">
          <p className="text-lg sm:text-xl font-bold text-center text-brand-text max-w-lg mx-auto leading-relaxed" data-id="element-193">
            No es tu cuerpo. Es que nadie te enseñó la ingeniería visual detrás
            de las prendas.
          </p>
        </FadeIn>
      </div>
    </section>;
}